import React from 'react';
import { baseUrl } from '../config.js';
// React Helmet does not accept components.
export const renderAlternateLinks = (currentLanguage, localizedSlugs) => ([
    ...Object.entries(localizedSlugs)
        .filter(([_, { isLocalized }]) => isLocalized)
        .map(([language, { url }]) => React.createElement("link", { key: url, rel: "alternate", hrefLang: language, href: `${baseUrl}${url}` })),
    localizedSlugs[currentLanguage] && React.createElement("link", { key: baseUrl, rel: "alternate", hrefLang: "x-default", href: `${baseUrl}${localizedSlugs[currentLanguage].url}` }),
]);
